import axiosClient from '../axiosClient';
const PREFIX_URL = 'crm/ho-tro';

const supportApi = {
    getUrl: (params) => {
        const url = `${PREFIX_URL}/getUrl`;
        return axiosClient.get(url, { params });
    },
};

export default supportApi;
